export type {
  ComparableTileProperties as ComparableTileProperties,
  ComparableTile,
} from "./External";

export type PropertyTypeShorthand = "D" | "S" | "T" | "F" | "O" | "C";

export enum PropertyTypesShort {
  DETACHED = "D",
  SEMI_DETACHED = "S",
  TERRACED = "T",
  FLAT = "F",
  OTHER = "O",
  COMMERCIAL = "C",
}

export enum PropertyTypeLabels {
  D = "comparables.property.types.detached",
  S = "comparables.property.types.semi_detached",
  T = "comparables.property.types.terraced",
  F = "comparables.property.types.flat_maisonette",
  C = "comparables.property.types.commercial",
}
